import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tag, Table, Empty, Button, Divider } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, } from "../../../common/types/regularExpresionType";
const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
class ViewModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };


    handleCancel = () => {
        this.props.onClose();
        //this.props.form.resetFields();
    }




    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Ver Apertura de Caja"}
                visible={this.props.visible}
                cancelText={"Cerrar"}
                okText={"Ok"}
                onCancel={this.handleCancel}
                onOk={this.handleCancel}
                style={{ top: 30 }}
                width="900px"
            >
                <Form>


                    <div className="row">

                        <div className="col-md-6">
                            <Form.Item label="Nro Planilla">


                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Serie"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.fechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("TipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.tipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "TipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                    </div>



                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.establecimientos.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select

                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.cajas.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <Form.Item label="Responsable de Manejo de Caja">
                                {getFieldDecorator('responsable', {
                                    initialValue: this.props.formValues.responsable,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Search
                                        readOnly
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={20}
                                    //loading={this.props.formValues.searchLoading}
                                    //onSearch={this.handleFilter}
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Moneda">
                                {getFieldDecorator("idMoneda", {
                                    initialValue: this.props.formValues.idMoneda
                                        ? { key: this.props.formValues.idMoneda }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Monto de Apertura">

                                <Form.Item>
                                    {getFieldDecorator(`montoApertura`, {
                                        initialValue: parseFloat(this.props.formValues.montoApertura).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }
                                        ]
                                    })(
                                        <Input
                                            placeholder="Monto Pen"
                                            autoComplete="off"
                                            readOnly
                                        />
                                    )}
                                </Form.Item>

                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label=".">

                                <Button
                                    icon="file-excel"
                                    onClick={this.props.onExportExcel}
                                    loading={this.props.loadingExcel}

                                    type="success"
                                    className="ml-10"
                                    ghost
                                >
                                    Exportar en Excel
                                </Button>
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <Divider>Solicitud de Efectivo</Divider>

                        </div>
                        <div className="col-md-12">
                            <Table
                                className={'table-producto'}
                                scroll={{ x: true }}
                                size="small"
                                style={{ overflowX: 'auto' }}
                                pagination={false}
                                dataSource={this.props.formValues.listaSolicitud}
                                rowKey={record => record.uid}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description='No se han agregado productos'
                                    />
                                }}
                                columns={[

                                    {
                                        title: 'Fecha Solicitud',
                                        dataIndex: 'fechaSolicitud',
                                        key: 'fechaSolicitud',
                                        sorter: true,
                                        render: (value, row) => (
                                            <span>{value} {row.hora}</span>
                                        )
                                    },

                                    {
                                        title: 'Fecha Sustento',
                                        dataIndex: 'fechaSustento',
                                        key: 'fechaSustento',
                                        sorter: true,
                                        render: (value, row) => (
                                            <span>{value} {row.horaCierre}</span>
                                        )
                                    },
                                    {
                                        title: 'Nro - Solicitud',
                                        dataIndex: 'numero',
                                        key: 'numero',
                                        sorter: true
                                    },
                                    {
                                        title: 'Centro de Costo',
                                        dataIndex: 'centroCosto',
                                        key: 'centroCosto',
                                        sorter: true
                                    },
                                    {
                                        title: 'Nro Documento',
                                        dataIndex: 'nroDocumento',
                                        key: 'nroDocumento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Empleado',
                                        dataIndex: 'empleado',
                                        key: 'empleado',
                                        sorter: true
                                    },
                                    {
                                        title: 'Moneda',
                                        dataIndex: 'moneda',
                                        key: 'moneda',
                                        sorter: true
                                    },
                                    {
                                        title: 'Monto Solicitado',
                                        dataIndex: 'montoSolicitud',
                                        key: 'montoSolicitud',
                                        align: 'right',
                                        render: (value) => (
                                            <span>{value.toFixed(2)}</span>
                                        )
                                    },
                                    {
                                        title: 'Monto Sustentado',
                                        dataIndex: 'montoSustento',
                                        key: 'montoSustento',
                                        align: 'right',
                                        render: (value, row) => {
                                            return (<>
                                                {(() => {
                                                    if (value > 0) {
                                                        return <Tag color={"blue"}> <span>{value.toFixed(2)}</span></Tag>

                                                    } else {
                                                        return <span>{value.toFixed(2)}</span>
                                                    }
                                                })()}

                                            </>)
                                        }
                                    },
                                    {
                                        title: 'Monto Devuelto a Caja',
                                        dataIndex: 'montoCaja',
                                        key: 'montoCaja',
                                        align: 'right',
                                        render: (value) => {
                                            return (<>
                                                {(() => {
                                                    if (parseFloat(value) > 0) {
                                                        return <Tag color={"green"}> <span>{value.toFixed(2)}</span></Tag>

                                                    } else {
                                                        return <span>{value.toFixed(2)}</span>
                                                    }
                                                })()}

                                            </>)
                                        }
                                    },
                                    {
                                        title: 'Monto Devuelto a Empleado',
                                        dataIndex: 'montoEmpleado',
                                        key: 'montoEmpleado',
                                        align: 'right',
                                        render: (value) => {
                                            return (<>
                                                {(() => {
                                                    if (parseFloat(value) > 0) {
                                                        return <Tag color={"red"}> <span>{value.toFixed(2)}</span></Tag>
                                                    } else {
                                                        return <span>{value.toFixed(2)}</span>
                                                    }
                                                })()}

                                            </>)
                                        }
                                    },

                                    {
                                        title: 'Monto Pendiente a Devolver',
                                        dataIndex: 'montoPendiente',
                                        key: 'montoPendiente',
                                        align: 'right',
                                        render: (value) => {
                                            return (<>
                                                {(() => {
                                                    if (parseFloat(value) > 0) {
                                                        return <Tag color={"red"}> <span>{value.toFixed(2)}</span></Tag>
                                                    } else {
                                                        return <span>{value.toFixed(2)}</span>
                                                    }
                                                })()}

                                            </>)
                                        }
                                    },

                                    {
                                        title: 'Estado',
                                        dataIndex: 'idEstado',
                                        key: 'idEstado',
                                        align: 'center',
                                        width: "90px",
                                        render: (value, row) => {
                                            return (<div className="custom-options" >
                                                {(() => {
                                                    switch (value) {
                                                        case 1: //registado
                                                            return <Tag color={"blue"}>{row.estado}</Tag>;
                                                        case 2://ANULADO
                                                            return <Tag color={"red"}>{row.estado}</Tag>;
                                                        case 4://CERRADO
                                                            return <Tag color={"red"}>{row.estado}</Tag>;
                                                        case 6://APROBADO
                                                            return <Tag color={"green"}>{row.estado}</Tag>;
                                                        default:
                                                            return null;
                                                    }
                                                })()}

                                            </div>)
                                        }
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(ViewModal)